import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import SideNav from '../SideNav/SideNav';
import AuthenticatedNavbar from '../AuthenticatedNavbar/AuthenticatedNavbar';
import BottomNav from '../BottomNav/BottomNav';

function DashboardLayout() {
    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useAuth();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const routeToTab = {
        '/discord': 'discord',
        '/manage-subscriptions': 'manage-subscriptions',
        '/snipe-feed': 'snipe-feed',
        '/odds-screen': 'odds-screen',
        '/results-tracker': 'results-tracker',
    };

    const defaultTab = user?.discordLinked ? 'snipe-feed' : 'discord';
    const activeTab = routeToTab[location.pathname] || defaultTab;

    const allMenuItems = [
        { id: 'discord', label: 'Discord', route: '/discord', showWhen: true },
        { id: 'manage-subscriptions', label: 'Manage Subscriptions', route: '/manage-subscriptions', showWhen: true },
        { id: 'snipe-feed', label: 'Snipe Feed', route: '/snipe-feed', showWhen: true },
        { id: 'odds-screen', label: 'Odds Screen', route: '/odds-screen', showWhen: true },
        { id: 'results-tracker', label: 'Results Tracker', route: '/results-tracker', showWhen: true },
    ];

    const menuItems = allMenuItems.filter(item => item.showWhen);

    const handleTabChange = (tabId) => {
        const menuItem = menuItems.find(item => item.id === tabId);
        if (menuItem) {
            navigate(menuItem.route);
            setIsMobileMenuOpen(false);
        }
    };

    const handleBottomNavChange = (tabId) => {
        const routes = {
            'discord': '/discord',
            'manage-subscriptions': '/manage-subscriptions',
            'snipe-feed': '/snipe-feed',
            'odds-screen': '/odds-screen',
            'results-tracker': '/results-tracker',
        };
        if (routes[tabId]) {
            navigate(routes[tabId]);
        }
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <div className="min-h-screen bg-[#020817]">
            {/* Sidebar - desktop only */}
            <SideNav 
                activeTab={activeTab}
                setActiveTab={handleTabChange}
            />

            {/* Main Content Wrapper */}
            <div className="min-h-screen flex flex-col ml-0 md:ml-[104px]">
                {/* Header - desktop only */}
                <div className="hidden md:block">
                    <AuthenticatedNavbar 
                        activeTab={activeTab} 
                        menuItems={menuItems}
                        toggleMobileMenu={toggleMobileMenu}
                        isMobileMenuOpen={isMobileMenuOpen}
                    />
                </div>

                {/* Page Content */}
                <main className="flex-1 flex flex-col pt-0 md:pt-[72px] pb-16 md:pb-0">
                    <Outlet />
                </main>
            </div>

            {/* Bottom Navigation - mobile only */}
            <BottomNav
                activeTab={activeTab}
                onTabChange={handleBottomNavChange}
            />
        </div>
    );
}

export default DashboardLayout;
